import script from "./RealizarProva.vue?vue&type=script&setup=true&lang=js"
export * from "./RealizarProva.vue?vue&type=script&setup=true&lang=js"

import "./RealizarProva.vue?vue&type=style&index=0&id=8a11d146&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a11d146"]])

export default __exports__